export const endPoints = {
 apiBaseUrl:process.env.REACT_APP_API_BASE_URL,
 api: {
   LOGIN_ENDPOINT: "admin/login",
   SIGNUP: "users/signup",    //account-management1/users/signup
   GET_BY_USERID: "users/userid", // 12  Append userid
   GET_BY_USERNAME: "users/username/", // userrname
   UPDATE_PERSONAL: "users/personal",
   UPDATE_PROFILE_IMAGE: "upload/profileimage",
   EMAIL_SUPPORT: "email/support",
   VERIFICATION_ENDPOINT: "users/validate",
   STATES: "states",
   rgTypes:'rgTypes',
   accountstatus:'accountstatus',
   playertypes:'playertypes',
   kycstatus:'kycstatus',
   UPDATE_EMAIL: "users/email",
   FORGOT_PASSWORD: "users/passwordlost/",
   GET_SPORTS_DATA: "api/sports/id", //sportsid 6046
   DELETE_USER: 'users/delete',
   ADD_USER: 'users/add',
   GET_ADMIN: 'users/admin',
   GET_ALL_USERS: 'users',  ///'users/all',  replace to load 
   GET_RISKMANAGER: 'users/riskmanager',
   //admin api section
   GET_USERS: 'users',
   GET_BETS: 'bets/all',
   Get_Block_User: 'bolck/users',
   Create_Staff: 'staff/create',
   Update_Staff: 'staff/update',
   Delete_Staff: 'staff/delete',
   get_All_Staff: 'staffs',
   get_Single_Staff: 'staff',
   GET_Action_List: 'historicalSearch',
   GET_Access_List: 'sessioneSearch',
   GET_QUESTIONS: 'questions',
   transactions: 'alltransactions',
   GET_DOCUMENTS: 'documentTypes',
   TRANSFER_SUMMARY_LIST: 'transfer/summary/list',
   TRANSFER_DETAIL_LIST: 'transfer/details/list',
   TRANSFER_SUMMARY_REPORT: 'transfer/summary/download',
   TRANSFER_DETAIL_REPORT: 'transfer/details/download',
   USERS_REPORT: 'users/download',
   USERS_BLOCK_REPORT: 'users/block/download',
   ACTION_REPORT: 'action/download',
   ACCESS_REPORT: 'access/download',
   GetUserLimit: 'user/limit/',
   SetUserLimit: 'user/limit',
   deposit: 'admin/transactions/deposit',
   withdraw: 'admin/transactions/withdrawal',
   fieldUpdate:'account/fieldupdate',
   userFieldUpdate:'user/fieldupdate',
   userSecret:'users/secret',
   userRGLimit:'user/rglimit',
   FANTASY_PROMO:'promo/get',
   FANTASY_ADD_PROMO:'promo/add',
   FANTASY_UPDATE_PROMO:'promo/update',
   PROMO_CAMPAIGN_ALL:'admin/promotions/all',
   PROMO_CAMPAIGN_ADD:'admin/promotions/add',
   PROMO_CAMPAIGN_UPDATE:'admin/promotions/update',
   PROMO_CAMPAIGN_DELETE:'admin/promotions/delete',
   PROMO_CAMPAIGN_USAGE:'admin/promotions/usage',
   RAKEBACK_TOGGLE:'rakeback/config/toggle',
   GET_IMAGE:'promotions',
   ADD_IMAGE:'addpromotions',
   UPDATE_IMAGE:'updatepromotions',
   UPLOAD_BANNER:'upload/bannerimage',
   CREATE_NOTE:'note/create',
   GET_NOTES:'note/usernotes',
   DELETE_NOTE:'note/delete',
   UPDATE_NOTE:'note/update',
   GET_ALL_BONUS:'bonus/all',
   CREATE_BONUS:'bonus/create',
   UPDATE_BONUS:'bonus/update',
   GETPROVIDERS:'api/casino/providers',
   ADDPROVIDERS:'api/casino/addProvider',
   UPDATEPROVIDERS:'api/casino/updateProvider',
   DELETE_PROVIDERS:'api/casino/deleteProvider/',
   GETMENU:'api/casino/menu',
   ADDMENU:'api/casino/addMenu',
   UPDATEMENU:'api/casino/updateMenu',
   DELETE_MENU:'api/casino/deleteMenu/',
   GETGAMES:'api/casino/games',
   ADDGAMES:'api/casino/addGame',
   UPDATEGAMES:'api/casino/updateGame',
   DELETE_GAMES:'api/casino/deleteGame/',
   GETFEATUREGAMES:'api/casino/featuregames',
   ADD_FEATUREGAMES:'api/casino/addFeatureGame',
   UPDATE_FEATUREGAMES:'api/casino/updateFeatureGame',
   DELETE_FEATUREGAMES:'api/casino/deleteFeatureGame/',
   GET_PROMO:'api/casino/promosadmin',
   ADD_PROMO:'api/casino/addPromo',
   UPDATE_PROMO:'api/casino/updatePromo',
   DELETE_PROMO:'api/casino/deletePromo/',
   GET_GIFT: 'api/casino/admingifts',          //'api/casino/gifts',
   ADD_GIFT:'api/casino/addGift',
   UPDATE_GIFT:'api/casino/updateGift',
   DELETE_GIFT:'api/casino/deleteGift/',
   GET_POPUP:'banner/all',
   ADD_POPUP:'banner/add',
   UPDATE_POPUP:'banner/update',
   GET_PACKAGE:'admin/packages',
   ADD_PACKAGE:'api/casino/addcoinpackage',
   MANUAL_DEPOSIT_CONFIG:'api/casino/manualdepositconfig',
   UPDATE_PACKAGE:'api/casino/updatecoinpackage',
   DELETE_PACKAGE:'api/casino/deletePackage/',
   GET_PACKAGE_AMOUNTS:'api/casino/package/',
   LINK_ACCOUNT:'user/linkaccount',
   GET_LINK_ACCOUNT:'user/linkaccounts',
   DELETE_BANNER: 'promotion/delete',
   DELETE_MARKETING: 'banner/delete',
   GAMES_BY_PROVIDER:'api/casino/gamesbyprovider/',
   FREE_GAMES_BY_PROVIDER:'api/casino/freeGamesByProvider/',
   GAME_BETS:'api/casino/gamebets/', // + {gameId}/{currency}
   DELINK_ACCOUNT:'user/delete/linkaccount',
   COOL_OFF: 'user/cooloff',
   USER_EXCLUDE: 'user/exclude',
   playerStatus:'playerstatus',
   UPDATE_REDEMPTIONCLAIM:'api/casino/updatebuytrans',
   GET_REDEMPTIONCLAIM:'api/casino/giftstransaction',
   GET_PAYMENTS:'api/payments',
   WITHDRAW_TRANSACTIONS:'allwithdraw',
   TRANSACTION_UPDATE:'transactions/updateForCrypto',
   UPDATE_CAMPAIGN:'api/campain/update',
   CREATE_CAMPAIGN:'api/campain/create',
   GET_ALL_CAMPAIGN: 'api/campain/get',
   UPDATE_COUPON:'api/coupon/update',
   CREATE_COUPON:'api/coupon/create',
   GET_ALL_COUPON: 'api/coupon/get',
   GET_ALL_TRACKING: '/api/coupon/used',
   GET_ALL_CAMPAIGN_USERS:'api/campain/users',
   GET_ALL_COUPON_USER:'api/coupon/users',
   DELETE_COUPON:'api/coupon/delete',
   DELETE_CAMPAIGN:'api/campain/delete',
   CREATE_BULK_BOUNS:'bonus/bulkadd',
   GET_ALL_ACTIVE_CAMPAIGN:"/api/campain/getactive",
   GET_TRANSACTION_DETAILS:"transactiondetails",

   GET_USER_TRANSACTION:'casinoplay/admingamelist',
   GET_COIN_TRANSACTION:'casinoskrill/payment/transactionsall',
   GET_COIN_TRANSAC_Details:'casinoplay/admingamelist',

   DEPOSIT_COIN: 'admin/coin/deposit',
   WITHDRAW_COIN: 'admin/coin/withdrawal',
   USER_COIN_TRANSACTION:'admin/transaction/users',
   CASINO_GAME_LIST:'casinoplay/gamelist',
   USER_CASINO_UPDATE:'admin/user/update',
   REFER_USERS:'referUsers',
   PACKAGE_USER_TRANS:'casinoskrill/payment/transactions',
   ADD_COIN_PACKAGE:'/api/casino/user/addcoinpackage',
   PAYMENT_METHOD:'getPaymentMode',
   UPDATE_PAYMENT:'updatePaymentMode',
   CREATE_VIP_PACKAGE:'api/bench/createpackage',
   UPDATE_VIP_PACKAGE:'/api/bench/updatepackage',
   GET_VIP_PACKAGES:'api/bench/packages',
   CONFIGURATION:'api/configuration/all',
   CONFIGURATION_CREATE:"api/configuration/create",
   CONFIGURATION_UPDATE:'api/configuration/update',
   GIFT_CASH_TRANSACTION: "withdraw/",
   DELTE_VIP_PACKAGE:'api/bench/deletepackage',
   GET_SOCIAL_POST:'post/get',
   UPDATE_SOCIAL_POST:'post/update',
   GAME_CATEGORY:'api/games/getcategory',
   ADD_CATEGORY:'api/casino/insertgamecategory',
   UPDATA_CATEGORY:'api/casino/updategamecategory',
   GET_CATEGORY:'api/games/getcategory',
   DELETE_CATEGORY:'api/casino/deletegamecategory/', // + {catId}
   MAIL_IN_LIST:'email/promo/get',
   DASHBOARD_GAME_LIST:'dashboard/usertransaction',
   SPINSAGA_GAMES:'api/selfgame/addGame',
   GET_SPINSAGA_GAMES:'api/selfgame/games',
   UPDATE_SPINSAGA_GAMES:'api/selfgame/updateGame',
  WITHDRAW_CARD_TRANSACTIONS:'allwithdrawCard',
  CARD_CASH_TRANSACTION_BY_USERID: "cardwithdraw/",
  TRANSACTION_UPDATE_FOR_CARD:'transactions/updateForCard',
   GET_WOF:'api/configuration/wof',
   UPDATE_WOF:'api/configuration/wof/update',
   GET_ALL_PACKAGE:'api/casino/allpackages',
   POPUP_OFFER_ALL:'api/popupOffer/all',
   POPUP_OFFER_ADD:'api/popupOffer/add',
   POPUP_OFFER_UPDATE:'api/popupOffer/update',
   POPUP_OFFER_DELETE:'api/popupOffer/delete/',              // + {id}
   POPUP_WOF_ALL:'api/popupWof/all',
   POPUP_WOF_UPDATE:'api/popupWof/update',
   POPUP_SEGMENTATION_ALL:'api/popupSegmentation/all',
   POPUP_SEGMENTATION_SAVE:'api/popupSegmentation/save',
   POPUP_STATS:'api/popups/stats',
   GET_ALL_LOTTERY:'lottery/all',
   CREATE_LOTTERY:'lottery/create',
   UPDATE_LOTTERY:'lottery/update',
   DELETE_LOTTERY:'lottery/delete',
   SETTLE_LOTTERY:'lottery/settle',
   GET_LOTTERY_TICKETS:'lottery',                            // append /{id}/tickets
   WITHDRAW_CRYPTO_TRANSACTIONS:'allwithdrawCrypto',
   CRYPTO_TRANSACTION_BY_USERID:'cryptowithdraw/',
   ALLOW_CRYPTO:'/transactions/updateForCrypto',
   MONTHLY_REWARDS:'monthlyRewards/all',
   UPDATE_MONTHLY_REWARDS:'monthlyRewards/update',
   CREATE_MONTHLY_REWARDS:'monthlyRewards/create',
   DELETE_MONTHLY_REWARDS:'monthlyRewards/delete/',         // + {id}
   GET_REWARDS_BY_STREAK_TYPE:'monthlyRewards/all/',        // + {streakTypeId}
   GET_ALL_STREAK_TYPES:'streakType/all',
   CREATE_STREAK_TYPE:'streakType/create',
   UPDATE_STREAK_TYPE:'streakType/update',
   DELETE_STREAK_TYPE:'streakType/delete/',                 // + {id}
   SERACH_GAME: "api/casino/searchgames",
   SEARCH_FREESPIN_GAMES:'api/casino/searchFreeSpinGames',
   GAME_DETAILS:'api/casino/gamedetail',
    ADD_FREE_SPINS:'api/casino/admin/freespin',
   GET_FREE_SPINS:'admin/frespins',
   FREE_ROUND_GRANT:'freeround/grant',
   FREE_ROUND_HISTORY:'freeround/history/', // + {playerId}
   TRANSACTION_REGENERATE:'transactions/regenerate',
   GET_AUDIENCE_SEGMENTS:'audience/segments',
   UTM_REPORT_SUMMARY:'api/v1/utm/report/summary',
   UTM_REPORT_CAMPAIGNS:'api/v1/utm/report/campaigns',
   UTM_REPORT_REVENUE:'api/v1/utm/report/revenue',
   UTM_REPORT_SIGNUPS:'api/v1/utm/report/signups',
   UTM_REPORT_MEDIUM:'api/v1/utm/report/medium',
   PWA_REPORT_FUNNEL:'api/v1/pwa/report/funnel',
   PWA_REPORT_DAILY:'api/v1/pwa/report/daily',
   PWA_REPORT_PLATFORMS:'api/v1/pwa/report/platforms',
   SURVEY_ALL:'api/admin/survey/all',
   SURVEY_GET:'api/admin/survey/get/',              // + {id}
   SURVEY_ADD:'api/admin/survey/add',
   SURVEY_UPDATE:'api/admin/survey/update',
   SURVEY_ACTIVE:'api/admin/survey/active/',        // + {id}/{bool}
   SURVEY_DELETE:'api/admin/survey/delete/',        // + {id}
   SURVEY_RESULTS:'api/admin/survey/results/',      // + {id}
   GET_ERROR_LOG:'errorlog/all',
   GET_ERROR_LOG_24H:'errorlog/last24hours',
   DASHBOARD_GAME_TRANSACTION:'dashboard/gametransaction/',      // + {page}
   DASHBOARD_BIGGEST_WINNERS:'dashboard/biggestwinners/',        // + {count}
      GET_BLOCK_DOMAIN:'admin/block-domain/list',
   ADD_BLOCK_DOMAIN:'admin/block-domain/add',
   DELETE_BLOCK_DOMAIN:'admin/block-domain/delete',

   GET_EXCHANGE_RATE:'api/exchange-rate/list',
   ADD_EXCHANGE_RATE:'api/exchange-rate/create',
   UPDATE_EXCHANGE_RATE:'api/exchange-rate/update',
   DELETE_EXCHANGE_RATE:'api/exchange-rate/',
   GET_TIERS:'api/exchange-rate/tiers',
   UPDATE_TIER_MULTIFACTOR:'api/exchange-rate/tier/multifactor',

   GET_HAPPY_HOURS:'happyHour/all',
   GET_HAPPY_HOUR:'happyHour/get/', // append id
   ADD_HAPPY_HOUR:'happyHour/create',
   UPDATE_HAPPY_HOUR:'happyHour/update',
   DELETE_HAPPY_HOUR:'happyHour/delete/', // append id
   GET_HAPPY_HOUR_TRANSLATIONS:'happyHour/translations/', // append id
   GET_HAPPY_HOUR_EARNINGS:'happyHour/earnings', // optional filter/sort query string
   GET_CONFIGURATION_TRANSLATIONS:'api/configuration/translations/', // append id
   GET_PACKAGE_TRANSLATIONS:'api/casino/packagetranslations/', // append id




 },
 mode: "Development",
};

export const paymentEndpoints = {
 apiBaseUrl: process.env.REACT_APP_API_BASE_URL_PAYMENT,
 api: {
   ACTIVATE: "payment/enroll",
   TRANSACTION_SUMMARY_LIST: 'transaction/summary',
   TRANSACTION_DETAIL_LIST: 'transaction/detailed',
   TRANSACTION_SUMMARY_REPORT: 'transaction/summary/download',
   TRANSACTION_DETAIL_REPORT: 'transaction/detailed/download',
   deposit_WithDraw: 'payment/transfers',
   GET_COIN_FEE:"api/casino/getFeesEstimateAll",
   SEARCH_COIN_FEE:"api/casino/getFeesEstimate",
   PAYOUT_VERIFY:'api/casino/payout/',          // + {external_id}/verify

 }
}

export const sportEndPoint = {
 apiBaseUrl:  process.env.REACT_APP_API_BASE_URL_SPORT,
 api: {
   leagueByIdUrl: "api/league/",
   leagueList: "api/leagues",
   sports: "api/sports/",
   GET_BETS: 'api/fantasy/all',
   EXPORT_BET_PDF: 'api/fantasy/download/pdf',
   EXPORT_BET_CSV: 'api/fantasy/download/csv',
   REPORT: 'api/fantasy/report',
   LIVE_BET_REPORT: 'api/fantasy/report/live',
   LIVE_BET_SUMMARY: 'api/fantasy/summary',
   all_bets: "api/fantasy/info",
 },
 mode: "Development",
};

export  const  DefaultImageBaseurl = 'https://cdn.spinsagacasino.com:5000/'

// Player-facing coin site that admin-generated player links point at (e.g. the
// Coin Package "Email Package" buy-coins URL). Set REACT_APP_STAGE=true in the
// stage build to get the stage-coin host; anything else (including unset) is
// prod. CRA only exposes REACT_APP_* vars, and always as strings, so compare
// against the string "true". No trailing slash: paths are appended as
// `${PlayerSiteUrl}/buy-coins`.
const isStage = process.env.REACT_APP_STAGE === "true";

export const PlayerSiteUrl = isStage
  ? "https://stage-coin.spinsagacasino.com"
  : "https://coin.spinsagacasino.com";

export default {};

